export const PRDCATIMGSIZE = {maxwidth:60,maxheight:60,minwidth:52,minheight:52,aspectratio:1/1};